import {
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AppService } from '@services/app.service';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent implements OnInit, OnDestroy {
  @HostBinding('class') class = 'login-box';

  public recoverPasswordForm: UntypedFormGroup;
  public isAuthLoading = false;

  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    private appService: AppService
  ) {
    this.recoverPasswordForm = new UntypedFormGroup({
      password: new UntypedFormControl(null, Validators.required),
      confirmPassword: new UntypedFormControl(null, Validators.required)
    });
  }

  ngOnInit(): void {
    this.renderer.addClass(
      document.querySelector('app-root'),
      'login-page'
    );

  }

  recoverPassword() {
    if (this.recoverPasswordForm.valid) {
      this.isAuthLoading = true;
      this.appService.recoverPassword(this.recoverPasswordForm.value).subscribe(
        () => {
          this.toastr.success('Password recovered successfully!');
          this.isAuthLoading = false;
        },
        () => {
          this.toastr.error('An error occurred while recovering the password.');
          this.isAuthLoading = false;
        }
      );
    } else {
      this.toastr.error('Hello world!', 'Toastr fun!');
    }
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(
      document.querySelector('app-root'),
      'login-page'
    );
  }
}
